import { inject, Injectable, DOCUMENT } from '@angular/core';
import { HeadService } from '@df/core/meta/head/head.service';
import map from 'lodash-es/map';
import { NDfs } from '../dfs.interfaces';

@Injectable({
    providedIn: 'root'
})
export class DfsCssService {
    /**
     * List of existing classes
     */
    private existingClasses: { [classname: string]: number } = {};

    /**
     * List of variables
     */
    private variables: { [scope: string]: { [varName: string]: string } } = {};

    private rulesLength = 0;
    /**
     * Style HTML element
     */
    private styleClasses: HTMLStyleElement;
    private styleVars: HTMLStyleElement;

    private headService = inject(HeadService);

    constructor() {
        // Create the <style> tag
        this.styleVars = this.headService.add({
            element: 'style',
            placement: 'top',
            ssr: true,
            attributes: {
                id: 'dfsStyleVars'
            }
        });
        this.styleClasses = this.headService.add({
            element: 'style',
            placement: 'top',
            ssr: true,
            attributes: {
                id: 'dfsStyle'
            }
        });
    }

    /**
     * Converts styles to class
     */
    toClass(property: string, value: string, styles: NDfs.ICssEntry[]): string {
        const className = this.getClassName(property, value);
        if (!this.existingClasses[className]) {
            this.addClass(className, styles);
        }
        return className;
    }

    /**
     * Sets variable
     * @param name
     * @param value
     */
    setVariable(scope: string, name: string, value: string, autoApply = true) {
        if (!this.variables[scope]) {
            this.variables[scope] = {};
        }
        this.variables[scope][name] = value;

        if (autoApply) {
            this.applyVariableChanges();
        }
    }

    applyVariableChanges() {
        this.setVariableStyle();
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private setVariableStyle() {
        this.styleVars.innerHTML = map(
            this.variables,
            (scopeVars, scope) =>
                `[${this.getScopeAttr(scope)}]{\n${map(scopeVars, (value, name) => [name, value].join(':')).join(`;\n`)}\n}`
        ).join(`\n`);
    }

    getScopeAttr(scope: string): string {
        return `_dfs_${scope}`;
    }

    /**
     * Generates class name for dfs entry
     */
    private getClassName(property: string, value: string): string {
        // return `dfs-${property}-${value}`.replaceAll('%', 'p').replaceAll('+', '_');
        return `dfs-${property}-${value}`.replace('%', 'p').replace('+', '_');
    }

    /**
     * Add css class
     */
    private addClass(className: string, styles: NDfs.ICssEntry[]) {
        this.styleClasses.sheet!.insertRule(
            `.${className}{${styles.map(style => `${style.prop}:${style.value};`).join('')}}`,
            this.rulesLength++
        );
        this.styleClasses.innerHTML += `.${className}{${styles.map(style => `${style.prop}:${style.value};`).join('')}}\n`;
        this.existingClasses[className] = 1;
    }
}
